export function ContactCardSkeleton() {
	return (
		<div className="flex w-full animate-pulse flex-row justify-between rounded-lg border border-violet-200 bg-violet-25 p-4 hover:border-gray-300">
			<div className="flex w-full items-end gap-8">
				<div className="flex w-[70px] flex-col items-center gap-2">
					<div className="h-16 w-16 rounded-full bg-gray-300" />
					<div className="flex flex-col items-center gap-1">
						<div className="h-4 w-12 rounded-full bg-gray-300" />
						<div className="h-4 w-8 rounded-full bg-gray-300" />
					</div>
				</div>
				<div className="flex w-full flex-col gap-2">
					<div className="h-5 w-32 rounded-full bg-gray-300" />
					<div className="flex flex-wrap justify-between gap-y-2">
						<div className="flex flex-col gap-2">
							<div className="h-4 w-24 rounded-full bg-gray-300" />
							<div className="h-4 w-40 rounded-full bg-gray-300" />
							<div className="flex gap-2">
								<div className="h-4 w-10 rounded-full bg-gray-300" />
								<div className="h-4 w-10 rounded-full bg-gray-300" />
							</div>
						</div>
						<div className="flex items-end gap-2">
							<div className="h-8 w-20 rounded-full bg-gray-300" />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
